window.SelectCheckboxUi = class
{
	selectedClass = "fa-solid fa-square-check text-primary";
	unselectedeClass = "fa-regular fa-square"
	
	constructor(select, options = {}) {
		const self = this;

		const $select = $(select).attr('plugin', '').addClass('d-none');
		$select.wrap(`<div class="d-flex flex-column" style="gap: 5px"></div>`);
		$select.prop('multiple', true);
		const $wrapper = $select.parent();

		this.$wrapper = $wrapper;
		this.$select = $select;

		// Obtén todas las opciones del select
		var options = select.options;

		// Itera a través de las opciones y accede a sus propiedades
		for (var index = 0; index < options.length; index++) {
			const option = options[index];

			const $option = $(
			`<div class="btn btn-default btn-xl btn-no-animation justify-content-start align-items-center" data-value="${option.value}" data-selected="false">
				<i class="${this.unselectedeClass} font-size-20 mr-10"></i>
				<div class="">${option.text}</div>
			</div>`);

			if($select.attr('value').split(',').indexOf(option.value) > -1) {
				$(option).prop('selected', true);
				$option.attr('data-selected', 'true');
			}

			$wrapper.append($option);

			$option.on('click', function(ev) {
				ev.stopPropagation();
				ev.preventDefault();
				const value = $(this).attr('data-value');
				const $option = $select.find(`option[value="${value}"]`);
				$option.prop('selected', !$option.prop('selected'));
				$(this).attr('data-selected', $option.prop('selected'));
				self.setSelected();
			});
		}	

		self.setSelected();
	}

	setSelected() {
		this.$wrapper.find('i').removeClass( this.selectedClass ).addClass( this.unselectedeClass );
		this.$wrapper.find(`[data-selected="true"] i`).removeClass( this.unselectedeClass ).addClass( this.selectedClass );
	}
	
}